import { Controller } from "@hotwired/stimulus"

// Recherche et chips de filtrage de la page « OddScore Academy » (/ressources,
// #2041). Le DOM est déjà entièrement rendu côté serveur (SEO) : ce contrôleur
// se contente de masquer/afficher les éléments déjà présents (`hidden`), jamais
// de fetch, de pagination ni de rendu client.
export default class extends Controller {
  static targets = ["input", "chip", "item", "chapter", "sub", "empty"]

  connect() {
    this.activeChapter = null
    this.query = ""
  }

  search(event) {
    this.query = event.target.value.trim().toLowerCase()
    this.applyFilters()
  }

  filterChapter(event) {
    const chip = event.currentTarget
    const key = chip.dataset.chapterKey
    const wasActive = chip.classList.contains("chip-active")

    this.chipTargets.forEach((c) => c.classList.remove("chip-active"))
    this.activeChapter = wasActive ? null : key
    if (this.activeChapter) chip.classList.add("chip-active")

    this.applyFilters()
  }

  applyFilters() {
    let anyVisible = false

    this.itemTargets.forEach((item) => {
      const matchesQuery = !this.query || item.dataset.searchText.includes(this.query)
      const matchesChapter = !this.activeChapter || item.dataset.chapterKey === this.activeChapter
      const visible = matchesQuery && matchesChapter
      item.hidden = !visible
      if (visible) anyVisible = true
    })

    this.subTargets.forEach((sub) => {
      const hasVisibleItem = this.itemTargets.some((item) => sub.contains(item) && !item.hidden)
      sub.hidden = !hasVisibleItem
    })

    this.chapterTargets.forEach((chapter) => {
      const key = chapter.dataset.chapterKey
      const chapterMatches = !this.activeChapter || this.activeChapter === key
      const hasVisibleItem = this.itemTargets.some(
        (item) => item.dataset.chapterKey === key && !item.hidden
      )
      chapter.hidden = !(chapterMatches && hasVisibleItem)
    })

    if (this.hasEmptyTarget) this.emptyTarget.hidden = anyVisible
  }
}
